import { ImageFit, Image, Stack, Text } from "@fluentui/react";
import { useBreakpoint } from "../../../Container/ContainerStyles";
import { BreakpointType } from "../../../Container/ContainerFluid";
import { appBannerStyles, descriptionStyles, lgAppBannerStyles, lgDescriptionStyles, lgTitleStyles, mdAppBannerStyles, mdDescriptionStyles, mdTitleStyles, smAppBannerStyles, smDescriptionStyles, smTitleStyles, titleStyles, xlAppBannerStyles, xlDescriptionStyles, xlTitleStyles, xxlAppBannerStyles, xxlDescriptionStyles, xxlTitleStyles } from "./Styles/RegisterWelcomeStyles";
import { containerStyles, formContainerStyles, imageContainerStyles, lgContainerStyles, lgImageContainerStyles, lgTitleContainerStyles, mdContainerStyles, mdImageContainerStyles, mdTitleContainerStyles, smContainerStyles, smImageContainerStyles, smTitleContainerStyles, titleContainerStyles, xlContainerStyles, xlImageContainerStyles, xlTitleContainerStyles, xxlContainerStyles, xxlImageContainerStyles, xxlTitleContainerStyles } from "../Common/Styles/CommonStyles";

import appBanner from '../../../../../Assets/Images/apppng dark.png';
import { RegisterService } from "../../Service/RegisterService";

export const RegisterWelcome: React.FC = () => {
    
    const isSM = useBreakpoint(BreakpointType.sm);
    const isMD = useBreakpoint(BreakpointType.md);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isXXL = useBreakpoint(BreakpointType.xxl);
    
    return (
        <Stack
            className={
                isSM ? 
                    smContainerStyles : 
                isMD ? 
                    mdContainerStyles :
                isLG ?
                    lgContainerStyles :
                isXL ?
                    xlContainerStyles :
                isXXL ?
                    xxlContainerStyles
                :
                    containerStyles
            }
        >
            <Stack
                horizontal
                horizontalAlign="center"
                className={
                    isSM ? 
                        smImageContainerStyles : 
                    isMD ? 
                        mdImageContainerStyles : 
                    isLG ?
                        lgImageContainerStyles :
                    isXL ? 
                        xlImageContainerStyles :
                    isXXL ?
                        xxlImageContainerStyles 
                    :
                        imageContainerStyles
                }
            >
                <Image 
                    src={appBanner} 
                    className={
                        isSM ? 
                            smAppBannerStyles : 
                        isMD ? 
                            mdAppBannerStyles :
                        isLG ?
                            lgAppBannerStyles :
                        isXL ? 
                            xlAppBannerStyles :
                        isXXL ?
                            xxlAppBannerStyles 
                        :
                            appBannerStyles
                    } 
                    imageFit={ImageFit.cover} 
                />
            </Stack>
            <Stack
                className={
                    isSM ? 
                        smTitleContainerStyles : 
                    isMD ? 
                        mdTitleContainerStyles :
                    isLG ?
                        lgTitleContainerStyles :
                    isXL ?
                        xlTitleContainerStyles :
                    isXXL ?
                        xxlTitleContainerStyles
                    :
                        titleContainerStyles
                }
            >
                <Text 
                    className={
                        isSM ? 
                            smTitleStyles : 
                        isMD ? 
                            mdTitleStyles : 
                        isLG ?
                            lgTitleStyles :
                        isXL ?
                            xlTitleStyles :
                        isXXL ?
                            xxlTitleStyles
                        :
                            titleStyles
                    }
                >
                    {RegisterService.translate("welcome:title")}
                </Text>
            </Stack>
            <Stack
                className={formContainerStyles}
            >
                <Text 
                    className={
                        isSM ? 
                            smDescriptionStyles : 
                        isMD ? 
                            mdDescriptionStyles :
                        isLG ?
                            lgDescriptionStyles :
                        isXL ?
                            xlDescriptionStyles :
                        isXXL ?
                            xxlDescriptionStyles
                        :
                            descriptionStyles
                    }
                >
                    {RegisterService.translate("welcome:description")}
                </Text>
            </Stack>
        </Stack>
    );
};